export const AREA_SEARCH = "AREA_SEARCH";
export const MANAGER_SEARCH = "MANAGER_SEARCH";
export const CORPORATION_SEARCH = "CORPORATION_SEARCH";
export const POSITION_SEARCH = "POSITION_SEARCH";
